module.exports = __webpack_public_path__ + "img/loading-3-quarters.1b0edc5e.svg";